import { render, staticRenderFns } from "./TheAccessControlToggleButton.vue?vue&type=template&id=2718bd75&scoped=true&lang=html&"
import script from "./TheAccessControlToggleButton.vue?vue&type=script&lang=ts&"
export * from "./TheAccessControlToggleButton.vue?vue&type=script&lang=ts&"
import style0 from "./TheAccessControlToggleButton.vue?vue&type=style&index=0&id=2718bd75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2718bd75",
  null
  
)

export default component.exports